import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function EmbedCode({ name }: { name: string }) {
  const snippet = `<script src="https://cdn.fanzbots.com/widget.js" data-bot="${name}"></script>`;
  const copy = async () => {
    await navigator.clipboard.writeText(snippet);
    toast.info("Embed code copied");
  };
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">Embed on your site</div>
      <Textarea readOnly value={snippet} className="font-mono text-xs" />
      <Button onClick={copy} size="sm">Copy code</Button>
    </div>
  );
}
